// extracted by mini-css-extract-plugin
module.exports = {"heading":"startup-jobs_heading__2_W7u","content":"startup-jobs_content__2cF1P","button":"startup-jobs_button__16_Ho","sending":"startup-jobs_sending__2TpnX"};